
import { Point } from '../models/point';
import { Texture, Sprite, Container, TextStyle, Text } from 'pixi.js';

export class ChatBubble {
    private messageTextPosition: Point = { x: 96, y: 47 };
    private messageTextStyle: TextStyle;

    public container: Container;
    private bubbleSprite: Sprite;
    private messegeText: Text;
    private messageToDisplay: string;
    private charIndex = 0;
    private timerRef: ReturnType<typeof setInterval>;

    constructor(textures: Texture, position: Point, data: { message: string; isVerticalLayout?: boolean; }) {
        const fontSize = data.isVerticalLayout ? 28 : 22;
        this.messageTextStyle = new TextStyle({
            fontFamily: 'Saira Semi Condensed',
            fontWeight: '400',
            fontSize,
            fill: '#000000',
            wordWrap: true,
            wordWrapWidth: 130,
            align: 'center'
        });

        this.container = new Container();
        this.container.position.set(position.x, position.y);

        this.bubbleSprite = new Sprite(textures);
        this.container.addChild(this.bubbleSprite);

        this.messegeText = new Text('', this.messageTextStyle);
        this.messegeText.anchor.set(0.5);
        this.messegeText.position.set(this.messageTextPosition.x, this.messageTextPosition.y);
        this.container.addChild(this.messegeText);

        this.messageToDisplay = data.message;

        this.timerRef = setInterval(() => this.doTextAnimation(), 25);
    }

    private doTextAnimation() {
        if (this.charIndex >= this.messageToDisplay.length) {
            clearInterval(this.timerRef);
            this.timerRef = null as any;
            setTimeout(() => this.selfDistruct(), 2000);
            return;
        }
        this.charIndex++;
        this.messegeText.text = this.messageToDisplay.substring(0, this.charIndex);
    }

    private selfDistruct() {
        if (this.timerRef) {
            clearInterval(this.timerRef);
            this.timerRef = null as any;
        }
        
        // 🔧 FIX: Explicitly destroy sprites and text to prevent canvas memory leaks
        if (this.bubbleSprite) {
            this.bubbleSprite.destroy({ children: true, texture: false });
            this.bubbleSprite = null as any;
        }
        if (this.messegeText) {
            this.messegeText.destroy({ children: true });
            this.messegeText = null as any;
        }
        
        if (this.container?.parent) {
            this.container.parent.removeChild(this.container);
        }
        this.container?.removeChildren();
        this.container?.destroy({ children: true, texture: false });
        this.container = null as any;
    }

    destroy() {
        if (this.timerRef) {
            clearInterval(this.timerRef);
            this.timerRef = null as any;
        }
        
        // 🔧 FIX: Explicitly destroy sprites and text to prevent canvas memory leaks
        if (this.bubbleSprite) {
            this.bubbleSprite.destroy({ children: true, texture: false });
            this.bubbleSprite = null as any;
        }
        if (this.messegeText) {
            this.messegeText.destroy({ children: true });
            this.messegeText = null as any;
        }
        
        if (this.container?.parent) {
            this.container.parent.removeChild(this.container);
        }
        this.container?.removeChildren();
        this.container?.destroy({ children: true, texture: false });
        this.container = null as any;
    }
}
